var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-drop-down-list-item',{attrs:{"title":_vm.$t('Title'),"icon":"DownloadCloudIcon","color":"success"},on:{"click-ntf":function($event){return _vm.openDownload()}}},[_c('small',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.message, {
              entity: _vm.$tc(`$Entities.${_vm.notification.payload.entity}`, 2),
              url: _vm.notification.payload.preSignedUrl,
            }))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }